import {Injectable}            from '@angular/core';
import {CampaignYearStore}     from '../../stores/login/campaignyear.store';
import {ISoilSamplingGridData} from '../types/base-fertilization-soil-sampleplanning.types';
import ISoilSampleField = Data.Nutrients.ISoilSampleField;

@Injectable({providedIn: 'root'})
export class ApSoilSampleService {
  constructor(private campaignYearStore: CampaignYearStore) {
  }

  public getFieldNumberAndSubNumber(soilSampleField: ISoilSampleField): string {
    if (soilSampleField.FieldNumber !== null) {
      if (soilSampleField.FieldPart !== null) {
        return `${soilSampleField.FieldNumber} - ${soilSampleField.FieldPart}`;
      } else {
        return `${soilSampleField.FieldNumber}`;
      }
    } else {
      if (soilSampleField.FieldPart !== null) {
        return `  - ${soilSampleField.FieldPart}`;
      } else {
        return '';
      }
    }
  }

  public getStatus(sampleDate: Date | string): number {
    if (!sampleDate) {
      return -1;
    }
    if (typeof sampleDate === typeof '') {
      sampleDate = new Date(sampleDate as string);
    }
    const difference = this.campaignYearStore.getSelectedCampaignYear().Year - this.getCampaignYear(sampleDate as Date);
    if (difference > 5) {
      return -1;
    } else if (difference > 3) {
      return 0;
    }
    return 1;
  }

  public getCampaignYear(sampleDate: Date): number {
    if (!sampleDate) {
      return undefined;
    }
    if (sampleDate.getMonth() > 5) {
      return sampleDate.getFullYear() + 1;
    }
    return sampleDate.getFullYear();
  }

  /**
   * Compares two dates
   * @param dateA
   * @param dateB
   * @private
   */
  public compareDates(dateA: Date, dateB: Date): number {
    if (!dateA) {
      return -1;
    } else if (!dateB) {
      return 1;
    }
    return dateA?.getTime() - dateB.getTime();
  }

  /**
   * Calculates the statistic bar color depending on item's status
   * @param item
   * @param date
   * @private
   */
  public getStatBarColor(item: ISoilSamplingGridData, date: Date): string {
    if (!date) {
      return '#2c3237';
    } else {
      switch (item.SamplingStatus.state) {
        case 0:
          return '#fdce3e';
        case 1:
          return '#5ec232';
        default:
          return '#980000';
      }
    }
  }
}
